import { h as __h } from "preact";
import { signal } from "@preact/signals";
import { Component, h } from "preact";
import { locationResponse } from "~/backend/validate.js";
/** @import WS from "~/lib/ws/ws.js"; */
import { query, paginatedResponse } from "~/lib/api.js";
import { identity } from "~/lib/identity.js";
import { SearchParams } from "~/lib/search.js";
import html from "~/util/html.js";
import { navigate } from "~/util/router.js";
/** @import { RouteParams } from "~/util/router.js"; */

import Button from "~/component/Button.js";
import Icon from "~/component/Icon.js";
import { Crumb } from "~/admin/component/Breadcrumbs.js";
import { ComboboxInput } from "~/admin/component/Combobox.js";
import FreshKeyCallout from "~/admin/component/FreshKeyCallout.js";
/** @import { FreshKey } from "~/admin/component/FreshKeyCallout.js"; */
import Pagination from "~/admin/component/Pagination.js";
import Table from "~/admin/component/Table.js";
import LocationsDetail from "./LocationsDetail.js";
import RelaysDetail from "./RelaysDetail.js";
/** @import { orgResponse } from "~/backend/validate.js"; */
import adminStyle from "~/admin/lib/style.js";
import { addLocation } from "~/admin/res/location/actions/addLocation.js";
import LocationTable from "~/admin/res/location/LocationTable.js";
import { addRelay } from "~/admin/res/relay/actions/addRelay.js";
import util from "~/style/util.js";

/**
 * @extends {Component<Props>}
 *
 * @typedef {{ org: orgResponse; ws: WS } & RouteParams<{
 * 	locationId: string | undefined;
 * 	relayId: string | undefined;
 * }>} Props
 */
export default class LocationsRoute extends Component {
  render() {
    const {
      locationId,
      relayId
    } = this.props.params.value;
    return [__h(Crumb, {}, locationId ? __h("a", {
      href: "/org/" + this.props.org.id + "/relays"
    }, "Relays") : "Relays"), relayId && locationId ? __h(RelaysDetail, {
      org: this.props.org,
      relayId: relayId
    }) : locationId ? __h(LocationsDetail, {
      org: this.props.org,
      locationId: locationId,
      ws: this.props.ws
    }) : __h(Locations, {
      org: this.props.org
    })];
  }
}

/**
 * @extends {Component<LocationsProps>}
 *
 * @typedef {object} LocationsProps
 * @property {orgResponse} org
 */
class Locations extends Component {
  paginate = new Pagination.State();
  sort = new Table.Sort({
    keys: ["name"],
    by: "name"
  });
  freshKey = signal(/** @type {FreshKey | null} */null);
  locations = query(() => ({
    key: [`/v2/orgs/${this.props.org.id}/locations`, {
      ...this.paginate.query(),
      ...this.sort.query(),
      q: SearchParams.q.value
    }],
    keepPreviousData: true
  }), {
    schema: paginatedResponse(locationResponse)
  });
  render() {
    const orgId = this.props.org.id;
    const canEditLocations = identity.permission(orgId, "locations", "edit");
    const canEditRelays = identity.permission(orgId, "relays", "edit");
    return __h("div", {
      "class": adminStyle.main
    }, __h(FreshKeyCallout, {
      freshKey: this.freshKey.value
    }), __h(ComboboxInput, {
      query: SearchParams.q,
      debounce: 200
    }), __h("div", {
      "class": adminStyle.body
    }, canEditLocations && __h("menu", {
      "class": adminStyle.menu
    }, __h(Button, {
      size: "small",
      onClick: async () => {
        const res = await addLocation({
          orgId
        });
        if (res) navigate(`/org/${orgId}/relays/${res.id}`);
      }
    }, __h(Icon, {
      name: "plus",
      size: 12
    }), __h("span", {}, "New location"))), __h("div", {
      "class": util.card + " " + adminStyle.tableCard
    }, h(LocationTable, {
      orgId,
      paginate: this.paginate,
      sort: this.sort,
      query: this.locations,
      onTripleDots: (items, location) => [...(canEditRelays ? [{
        icon: "plus",
        text: "Add relay",
        onSelect: async () => {
          const res = await addRelay({
            orgId
          }, location);
          if (res) this.freshKey.value = res;
        }
      }] : []), ...items]
    }))));
  }
}